import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import AgentServices from "../../components/branches/reports/AgentServices";
import { getReportDescription } from "../../store/helpers";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
  normalizeRenderConfig,
} from "../../store/renderConfig";

const AgentTicketsPerService = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;

  const title = `${reportIndex}. Agent Tickets Per Service`;
  const description = getReportDescription(reportRange).AgentTicketsByService;
  const effectiveRenderConfig = {
    ...normalizeRenderConfig(renderConfig, {
      columnDefinitions: AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
    }),
    charts: { enabled: false },
  };
  const presentationSummaryItems = getRenderConfigSummaryItems(effectiveRenderConfig, {
    columnDefinitions: AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  //requires array of objects
  if (!_.isArray(data)) {
    data = [data];
  }  

  return (
    <Box>
        {!_.isEmpty(data) ? (
          <>
            <AgentServices
              reportIndex={reportIndex}
              data={data}
              reportTitle={title}
              reportDescription={description}
              presentationSummaryItems={presentationSummaryItems}
            />
          </>
        ) : (
          <Box mt={10}>
            <h1>{title}</h1>
            <p>{description}</p>
            <p>No data available in this report</p>
          </Box>
        )}
    </Box>
  );
};

export default AgentTicketsPerService;
